// utils/phoneCapture.js
// P2-B — pure helpers for the phone-capture path (Spec D).
//
// needsPhoneCapture: decides whether the post-sign-in phone-capture card should
// show for a profile. Pure, no imports, no side effects. Used by App.modular's
// single conditional render and unit-tested directly.
//
// isPlausiblePhone: minimal client-side sanity check (>= 10 digits). Deliberately
// permissive — real validation belongs to the SMS layer, which this branch does
// NOT touch. Formatting is preserved as typed.
//
// Original IP — LoadDash Services.

/**
 * @param {object|null|undefined} profile - user_profiles row (or null when absent)
 * @returns {boolean} true when a signed-in user has no usable phone on file
 */
export function needsPhoneCapture(profile) {
  if (!profile) return true;
  const p = typeof profile.phone === "string" ? profile.phone.trim() : "";
  return p.length === 0;
}

/**
 * @param {string} value
 * @returns {boolean} true when the string contains at least 10 digits
 */
export function isPlausiblePhone(value) {
  if (typeof value !== "string") return false;
  return (value.match(/\d/g) || []).length >= 10;
}

/**
 * Normalize a US phone number to E.164 for storage. Strips non-digits;
 * 10 digits gets a +1 prefix, 11 digits starting with 1 gets a + prefix.
 * Anything else is not a valid US mobile number.
 * @param {string} value
 * @returns {string|null} "+1XXXXXXXXXX" or null when not normalizable
 */
export function toE164US(value) {
  if (typeof value !== "string") return null;
  const digits = value.replace(/\D/g, "");
  if (digits.length === 10) return "+1" + digits;
  if (digits.length === 11 && digits.startsWith("1")) return "+" + digits;
  return null;
}
